enum ToiletTypes {
  Men = 'man',
  Women = 'woman',
  Mixed = 'Mixed',
  Disabled = 'disabled',
  Ambulatory = 'ambulatory',
}

export default ToiletTypes;
